module.exports = __webpack_public_path__ + "img/2595.658515bd.png";